var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQuestionMarkWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.0557 12.0557c0-4.9706-4.0295-9.00004-9-9.00004-4.9706 0-9.00004 4.02944-9.00004 9.00004 0 4.9705 4.02944 9 9.00004 9 4.9705 0 9-4.0295 9-9z",
    fill: "#ebeef6",
    stroke: "#ebeef6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.2611 10.0227c0-.54029-.2146-1.05845-.5967-1.44049-.3821-.38205-.9003-.59668-1.4406-.59668s-1.0585.21463-1.4406.59668c-.382.38204-.5967.9002-.5967 1.44049",
    stroke: "#3856a7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12.2233 16.1749c-.0774-.002-.1536.0192-.2188.061-.0652.0417-.1164.1021-.1469.1732-.0306.0711-.0391.1498-.0245.2258s.0517.1459.1064.2006c.0548.0548.1247.0919.2007.1065s.1547.006.2258-.0245c.0712-.0306.1315-.0817.1732-.1469.0418-.0652.063-.1414.061-.2188 0-.1-.0397-.1958-.1104-.2665s-.1665-.1104-.2665-.1104z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3856a7",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.2233 16.1749c-.0774-.002-.1536.0192-.2188.061-.0652.0417-.1164.1021-.1469.1732-.0306.0711-.0391.1498-.0245.2258s.0517.1459.1064.2006c.0548.0548.1247.0919.2007.1065s.1547.006.2258-.0245c.0712-.0306.1315-.0817.1732-.1469.0418-.0652.063-.1414.061-.2188 0-.1-.0397-.1958-.1104-.2665s-.1665-.1104-.2665-.1104",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.2609 10.0227c-.013.3315-.1143.6536-.2934.9329-.1791.2794-.4294.5058-.7253.6561",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.2236 13.2415c.009-.3379.1083-.6671.2874-.9537.1791-.2865.4316-.52.7313-.6761",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.2236 13.2415v.2546",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQuestionMarkWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/question_mark_white.c50db34002bdde8cd0eabf3d8b2d877f.svg";